var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};

// src/lib/AsyncAutocomplete.tsx
import { AsyncAutocomplete } from "@availity/mui-autocomplete";
import { Controller, useFormContext } from "react-hook-form";
import { Fragment, jsx, jsxs } from "react/jsx-runtime";
var ControlledAsyncAutocomplete = (_a) => {
  var _b = _a, {
    name,
    onBlur,
    onChange,
    rules = {},
    shouldUnregister,
    value,
    FieldProps,
    defaultToFirstOption,
    defaultToOnlyOption,
    transform
  } = _b, rest = __objRest(_b, [
    "name",
    "onBlur",
    "onChange",
    "rules",
    "shouldUnregister",
    "value",
    "FieldProps",
    "defaultToFirstOption",
    "defaultToOnlyOption",
    "transform"
  ]);
  const { setValue } = useFormContext();
  return /* @__PURE__ */ jsx(
    Controller,
    {
      name,
      defaultValue: rest.defaultValue,
      rules: __spreadValues({ onBlur, onChange, shouldUnregister, value }, rules),
      shouldUnregister,
      render: ({ field: { onChange: onChange2, value: value2, onBlur: onBlur2, ref }, fieldState: { error } }) => {
        var _a2, _b2, _c;
        return /* @__PURE__ */ jsx(
          AsyncAutocomplete,
          __spreadProps(__spreadValues({}, rest), {
            FieldProps: __spreadProps(__spreadValues({
              required: typeof rules.required === "object" ? rules.required.value : !!rules.required
            }, FieldProps), {
              error: !!error,
              helperText: (error == null ? void 0 : error.message) ? /* @__PURE__ */ jsxs(Fragment, { children: [
                error.message,
                /* @__PURE__ */ jsx("br", {}),
                FieldProps == null ? void 0 : FieldProps.helperText
              ] }) : FieldProps == null ? void 0 : FieldProps.helperText,
              inputRef: ref
            }),
            onChange: (event, value3, reason) => {
              var _a3, _b3, _c2, _d;
              if (reason === "clear") {
                onChange2((_b3 = (_a3 = transform == null ? void 0 : transform.output) == null ? void 0 : _a3.call(transform, null)) != null ? _b3 : null);
              }
              onChange2((_d = (_c2 = transform == null ? void 0 : transform.output) == null ? void 0 : _c2.call(transform, value3)) != null ? _d : value3);
            },
            onBlur: onBlur2,
            value: (_c = (_b2 = (_a2 = transform == null ? void 0 : transform.input) == null ? void 0 : _a2.call(transform, value2)) != null ? _b2 : value2) != null ? _c : null,
            loadOptions: (offset, limit, inputValue) => __async(void 0, null, function* () {
              const { options, hasMore, offset: returnedOffsetValue } = yield rest.loadOptions(offset, limit, inputValue);
              if (defaultToFirstOption && offset === 0) {
                setValue(name, rest.multiple ? [options[0]] : options[0]);
              }
              if (defaultToOnlyOption && offset === 0 && options.length === 1) {
                setValue(name, rest.multiple ? [options[0]] : options[0]);
              }
              return { options, hasMore, offset: returnedOffsetValue };
            })
          })
        );
      }
    }
  );
};

// src/lib/Autocomplete.tsx
import { Autocomplete } from "@availity/mui-autocomplete";
import { Controller as Controller2 } from "react-hook-form";
import { Fragment as Fragment2, jsx as jsx2, jsxs as jsxs2 } from "react/jsx-runtime";
var ControlledAutocomplete = (_a) => {
  var _b = _a, {
    name,
    FieldProps,
    defaultValue,
    rules = {},
    onBlur,
    onChange,
    shouldUnregister,
    value,
    transform
  } = _b, rest = __objRest(_b, [
    "name",
    "FieldProps",
    "defaultValue",
    "rules",
    "onBlur",
    "onChange",
    "shouldUnregister",
    "value",
    "transform"
  ]);
  return /* @__PURE__ */ jsx2(
    Controller2,
    {
      name,
      defaultValue,
      rules: __spreadValues({
        onBlur,
        onChange,
        shouldUnregister,
        value
      }, rules),
      shouldUnregister,
      render: ({ field: { onChange: onChange2, value: value2, onBlur: onBlur2, ref }, fieldState: { error } }) => {
        var _a2, _b2, _c;
        return /* @__PURE__ */ jsx2(
          Autocomplete,
          __spreadProps(__spreadValues({}, rest), {
            FieldProps: __spreadProps(__spreadValues({
              required: typeof rules.required === "object" ? rules.required.value : !!rules.required
            }, FieldProps), {
              error: !!error,
              helperText: (error == null ? void 0 : error.message) ? /* @__PURE__ */ jsxs2(Fragment2, { children: [
                error.message,
                /* @__PURE__ */ jsx2("br", {}),
                FieldProps == null ? void 0 : FieldProps.helperText
              ] }) : FieldProps == null ? void 0 : FieldProps.helperText,
              inputRef: ref
            }),
            onChange: (event, value3, reason) => {
              var _a3, _b3, _c2, _d;
              if (reason === "clear") {
                onChange2((_b3 = (_a3 = transform == null ? void 0 : transform.output) == null ? void 0 : _a3.call(transform, null)) != null ? _b3 : null);
              }
              onChange2((_d = (_c2 = transform == null ? void 0 : transform.output) == null ? void 0 : _c2.call(transform, value3)) != null ? _d : value3);
            },
            onBlur: onBlur2,
            value: (_c = (_b2 = (_a2 = transform == null ? void 0 : transform.input) == null ? void 0 : _a2.call(transform, value2)) != null ? _b2 : value2) != null ? _c : null
          })
        );
      }
    }
  );
};

// src/lib/Checkbox.tsx
import { Checkbox } from "@availity/mui-checkbox";
import { Controller as Controller3 } from "react-hook-form";
import { jsx as jsx3 } from "react/jsx-runtime";
var ControlledCheckbox = (_a) => {
  var _b = _a, {
    name,
    disabled,
    onChange,
    onBlur,
    value,
    defaultValue = false,
    rules = {},
    shouldUnregister,
    transform
  } = _b, rest = __objRest(_b, [
    "name",
    "disabled",
    "onChange",
    "onBlur",
    "value",
    "defaultValue",
    "rules",
    "shouldUnregister",
    "transform"
  ]);
  return /* @__PURE__ */ jsx3(
    Controller3,
    {
      name,
      defaultValue,
      disabled,
      rules: __spreadValues({
        onChange,
        onBlur,
        value,
        shouldUnregister
      }, rules),
      shouldUnregister,
      render: ({ field }) => {
        var _a2, _b2;
        return /* @__PURE__ */ jsx3(
          Checkbox,
          __spreadProps(__spreadValues(__spreadValues({
            required: typeof rules.required === "object" ? rules.required.value : !!rules.required
          }, rest), field), {
            checked: (_b2 = (_a2 = transform == null ? void 0 : transform.input) == null ? void 0 : _a2.call(transform, field.value)) != null ? _b2 : field.value,
            onChange: (e) => {
              var _a3, _b3;
              return field.onChange((_b3 = (_a3 = transform == null ? void 0 : transform.output) == null ? void 0 : _a3.call(transform, e.target.checked)) != null ? _b3 : e.target.checked);
            }
          })
        );
      }
    }
  );
};

// src/lib/CodesAutocomplete.tsx
import { fetchCodes, handleGetCodesOptionLabel } from "@availity/mui-autocomplete";
import { jsx as jsx4 } from "react/jsx-runtime";
var ControlledCodesAutocomplete = (_a) => {
  var _b = _a, {
    apiConfig = {},
    queryOptions,
    queryKey = "codes-autocomplete",
    list,
    watchParams
  } = _b, rest = __objRest(_b, [
    "apiConfig",
    "queryOptions",
    "queryKey",
    "list",
    "watchParams"
  ]);
  const handleLoadOptions = (offset, limit, inputValue) => __async(void 0, null, function* () {
    const resp = yield fetchCodes(__spreadProps(__spreadValues({}, apiConfig), {
      params: __spreadProps(__spreadValues({}, apiConfig.params), { list, offset, limit, q: inputValue })
    }));
    return resp;
  });
  return /* @__PURE__ */ jsx4(
    ControlledAsyncAutocomplete,
    __spreadProps(__spreadValues({
      getOptionLabel: handleGetCodesOptionLabel,
      queryKey,
      queryOptions: __spreadValues({ enabled: !!list }, queryOptions),
      watchParams: __spreadValues({ list }, watchParams)
    }, rest), {
      loadOptions: handleLoadOptions
    })
  );
};

// src/lib/Datepicker.tsx
import { Datepicker } from "@availity/mui-datepicker";
import { Controller as Controller4 } from "react-hook-form";
import { Fragment as Fragment3, jsx as jsx5, jsxs as jsxs3 } from "react/jsx-runtime";
var ControlledDatepicker = (_a) => {
  var _b = _a, {
    name,
    defaultValue,
    onBlur,
    onChange,
    rules = {},
    shouldUnregister,
    value,
    FieldProps,
    transform
  } = _b, rest = __objRest(_b, [
    "name",
    "defaultValue",
    "onBlur",
    "onChange",
    "rules",
    "shouldUnregister",
    "value",
    "FieldProps",
    "transform"
  ]);
  return /* @__PURE__ */ jsx5(
    Controller4,
    {
      name,
      defaultValue,
      rules: __spreadValues({
        onBlur,
        onChange,
        shouldUnregister,
        value
      }, rules),
      shouldUnregister,
      render: ({ field: { onChange: onChange2, value: value2, onBlur: onBlur2, ref }, fieldState: { error } }) => {
        var _a2;
        return /* @__PURE__ */ jsx5(
          Datepicker,
          __spreadProps(__spreadValues({}, rest), {
            FieldProps: __spreadProps(__spreadValues({
              required: typeof rules.required === "object" ? rules.required.value : !!rules.required
            }, FieldProps), {
              error: !!error,
              helperText: error ? /* @__PURE__ */ jsxs3(Fragment3, { children: [
                error.message,
                /* @__PURE__ */ jsx5("br", {}),
                FieldProps == null ? void 0 : FieldProps.helperText
              ] }) : FieldProps == null ? void 0 : FieldProps.helperText,
              inputRef: ref,
              inputProps: {
                onBlur: onBlur2
              }
            }),
            onChange: (e) => {
              var _a3, _b2;
              return onChange2((_b2 = (_a3 = transform == null ? void 0 : transform.output) == null ? void 0 : _a3.call(transform, e)) != null ? _b2 : e);
            },
            value: ((_a2 = transform == null ? void 0 : transform.input) == null ? void 0 : _a2.call(transform, value2)) || value2 || null
          })
        );
      }
    }
  );
};

// src/lib/Input.tsx
import { Input } from "@availity/mui-form-utils";
import { Controller as Controller5 } from "react-hook-form";
import { jsx as jsx6 } from "react/jsx-runtime";
var ControlledInput = (_a) => {
  var _b = _a, {
    name,
    defaultValue,
    disabled,
    onBlur,
    onChange,
    rules = {},
    shouldUnregister,
    value,
    transform
  } = _b, rest = __objRest(_b, [
    "name",
    "defaultValue",
    "disabled",
    "onBlur",
    "onChange",
    "rules",
    "shouldUnregister",
    "value",
    "transform"
  ]);
  return /* @__PURE__ */ jsx6(
    Controller5,
    {
      name,
      defaultValue,
      disabled,
      rules: __spreadValues({
        onChange,
        onBlur,
        value,
        shouldUnregister
      }, rules),
      shouldUnregister,
      render: ({ field, fieldState: { error } }) => {
        var _a2, _b2, _c;
        return /* @__PURE__ */ jsx6(
          Input,
          __spreadProps(__spreadValues(__spreadValues({
            required: typeof rules.required === "object" ? rules.required.value : !!rules.required
          }, rest), field), {
            onChange: (e) => {
              var _a3, _b3;
              return field.onChange((_b3 = (_a3 = transform == null ? void 0 : transform.output) == null ? void 0 : _a3.call(transform, e.target.value)) != null ? _b3 : e);
            },
            value: (_c = (_b2 = (_a2 = transform == null ? void 0 : transform.input) == null ? void 0 : _a2.call(transform, field.value)) != null ? _b2 : field.value) != null ? _c : "",
            error: !!error
          })
        );
      }
    }
  );
};

// src/lib/OrganizationAutocomplete.tsx
import { handleGetOrgOptionLabel, fetchOrgs } from "@availity/mui-autocomplete";
import { jsx as jsx7 } from "react/jsx-runtime";
var ControlledOrganizationAutocomplete = (_a) => {
  var _b = _a, {
    queryKey = "org-autocomplete",
    apiConfig = {}
  } = _b, rest = __objRest(_b, [
    "queryKey",
    "apiConfig"
  ]);
  const handleLoadOptions = (offset, limit) => __async(void 0, null, function* () {
    const resp = yield fetchOrgs(__spreadProps(__spreadValues({}, apiConfig), { params: __spreadProps(__spreadValues({ dropdown: true }, apiConfig.params), { offset, limit }) }));
    return resp;
  });
  return /* @__PURE__ */ jsx7(
    ControlledAsyncAutocomplete,
    __spreadProps(__spreadValues({
      getOptionLabel: handleGetOrgOptionLabel,
      queryKey
    }, rest), {
      loadOptions: handleLoadOptions
    })
  );
};

// src/lib/ProviderAutocomplete.tsx
import { handleGetProviderOptionLabel, fetchProviders } from "@availity/mui-autocomplete";
import { jsx as jsx8 } from "react/jsx-runtime";
var ControlledProviderAutocomplete = (_a) => {
  var _b = _a, {
    apiConfig = {},
    customerId,
    queryKey = "prov-autocomplete"
  } = _b, rest = __objRest(_b, [
    "apiConfig",
    "customerId",
    "queryKey"
  ]);
  const handleLoadOptions = (offset, limit, inputValue) => __async(void 0, null, function* () {
    const resp = yield fetchProviders(customerId, __spreadProps(__spreadValues({}, apiConfig), {
      params: __spreadProps(__spreadValues({}, apiConfig.params), { offset, limit, q: inputValue })
    }));
    return resp;
  });
  return /* @__PURE__ */ jsx8(
    ControlledAsyncAutocomplete,
    __spreadProps(__spreadValues({
      getOptionLabel: handleGetProviderOptionLabel,
      queryOptions: { enabled: !!customerId },
      queryKey,
      watchParams: { customerId }
    }, rest), {
      loadOptions: handleLoadOptions
    })
  );
};

// src/lib/RadioGroup.tsx
import { RadioGroup } from "@availity/mui-form-utils";
import { Controller as Controller6 } from "react-hook-form";
import { FormControl, FormLabel, FormHelperText } from "@availity/mui-form-utils";
import { Fragment as Fragment4, jsx as jsx9, jsxs as jsxs4 } from "react/jsx-runtime";
var ControlledRadioGroup = (_a) => {
  var _b = _a, {
    name,
    helperText,
    label,
    defaultValue,
    onBlur,
    onChange,
    required,
    rules = {},
    shouldUnregister,
    value,
    transform
  } = _b, rest = __objRest(_b, [
    "name",
    "helperText",
    "label",
    "defaultValue",
    "onBlur",
    "onChange",
    "required",
    "rules",
    "shouldUnregister",
    "value",
    "transform"
  ]);
  return /* @__PURE__ */ jsx9(
    Controller6,
    {
      name,
      defaultValue,
      rules: __spreadValues({ onBlur, onChange, shouldUnregister, value }, rules),
      shouldUnregister,
      render: (_a2) => {
        var _b2 = _a2, { field: _c } = _b2, _d = _c, { disabled } = _d, field = __objRest(_d, ["disabled"]), { fieldState: { error } } = _b2;
        var _a3, _b3, _c2;
        return /* @__PURE__ */ jsxs4(
          FormControl,
          {
            error: !!error,
            disabled,
            required: !!required || (typeof rules.required === "object" ? rules.required.value : !!rules.required),
            children: [
              /* @__PURE__ */ jsx9(FormLabel, { children: label }),
              /* @__PURE__ */ jsx9(
                RadioGroup,
                __spreadValues(__spreadProps(__spreadValues({}, field), {
                  onChange: (e) => {
                    var _a4, _b4;
                    return field.onChange((_b4 = (_a4 = transform == null ? void 0 : transform.output) == null ? void 0 : _a4.call(transform, e.target.value)) != null ? _b4 : e);
                  },
                  value: (_c2 = (_b3 = (_a3 = transform == null ? void 0 : transform.input) == null ? void 0 : _a3.call(transform, field.value)) != null ? _b3 : field.value) != null ? _c2 : ""
                }), rest)
              ),
              /* @__PURE__ */ jsx9(FormHelperText, { children: (error == null ? void 0 : error.message) ? /* @__PURE__ */ jsxs4(Fragment4, { children: [
                error.message,
                /* @__PURE__ */ jsx9("br", {}),
                helperText
              ] }) : helperText })
            ]
          }
        );
      }
    }
  );
};

// src/lib/Select.tsx
import { Select } from "@availity/mui-form-utils";
import { Controller as Controller7 } from "react-hook-form";
import { jsx as jsx10 } from "react/jsx-runtime";
var ControlledSelect = (_a) => {
  var _b = _a, {
    name,
    defaultValue,
    disabled,
    onBlur,
    onChange,
    rules = {},
    shouldUnregister,
    value,
    transform
  } = _b, rest = __objRest(_b, [
    "name",
    "defaultValue",
    "disabled",
    "onBlur",
    "onChange",
    "rules",
    "shouldUnregister",
    "value",
    "transform"
  ]);
  return /* @__PURE__ */ jsx10(
    Controller7,
    {
      name,
      defaultValue,
      disabled,
      rules: __spreadValues({
        onChange,
        onBlur,
        value,
        shouldUnregister
      }, rules),
      shouldUnregister,
      render: ({ field, fieldState: { error } }) => {
        var _a2, _b2, _c;
        return /* @__PURE__ */ jsx10(
          Select,
          __spreadProps(__spreadValues(__spreadValues({
            required: typeof rules.required === "object" ? rules.required.value : !!rules.required
          }, rest), field), {
            onChange: (e) => {
              var _a3, _b3;
              return field.onChange((_b3 = (_a3 = transform == null ? void 0 : transform.output) == null ? void 0 : _a3.call(transform, e.target.value)) != null ? _b3 : e);
            },
            value: (_c = (_b2 = (_a2 = transform == null ? void 0 : transform.input) == null ? void 0 : _a2.call(transform, field.value)) != null ? _b2 : field.value) != null ? _c : "",
            error: !!error
          })
        );
      }
    }
  );
};

// src/lib/TextField.tsx
import { TextField } from "@availity/mui-textfield";
import { Controller as Controller8 } from "react-hook-form";
import { Fragment as Fragment5, jsx as jsx11, jsxs as jsxs5 } from "react/jsx-runtime";
var ControlledTextField = (_a) => {
  var _b = _a, {
    name,
    defaultValue,
    disabled,
    helperText,
    onBlur,
    onChange,
    rules = {},
    shouldUnregister,
    value,
    transform
  } = _b, rest = __objRest(_b, [
    "name",
    "defaultValue",
    "disabled",
    "helperText",
    "onBlur",
    "onChange",
    "rules",
    "shouldUnregister",
    "value",
    "transform"
  ]);
  return /* @__PURE__ */ jsx11(
    Controller8,
    {
      name,
      defaultValue,
      disabled,
      rules: __spreadValues({
        onChange,
        onBlur,
        value,
        shouldUnregister
      }, rules),
      shouldUnregister,
      render: (_a2) => {
        var _b2 = _a2, { field: _c } = _b2, _d = _c, { ref } = _d, field = __objRest(_d, ["ref"]), { fieldState: { error } } = _b2;
        var _a3, _b3, _c2, _d2;
        return /* @__PURE__ */ jsx11(
          TextField,
          __spreadProps(__spreadValues(__spreadProps(__spreadValues({
            required: typeof rules.required === "object" ? rules.required.value : !!rules.required
          }, field), {
            onChange: (e) => {
              var _a4, _b4;
              return field.onChange((_b4 = (_a4 = transform == null ? void 0 : transform.output) == null ? void 0 : _a4.call(transform, e.target.value)) != null ? _b4 : e);
            },
            value: (_c2 = (_b3 = (_a3 = transform == null ? void 0 : transform.input) == null ? void 0 : _a3.call(transform, field.value)) != null ? _b3 : field.value) != null ? _c2 : ""
          }), rest), {
            slotProps: __spreadProps(__spreadValues({}, rest.slotProps), {
              htmlInput: __spreadValues({
                maxLength: typeof rules.maxLength === "object" ? rules.maxLength.value : rules.maxLength
              }, (_d2 = rest.slotProps) == null ? void 0 : _d2.htmlInput)
            }),
            inputRef: ref,
            error: !!error,
            helperText: (error == null ? void 0 : error.message) ? /* @__PURE__ */ jsxs5(Fragment5, { children: [
              error.message,
              /* @__PURE__ */ jsx11("br", {}),
              helperText
            ] }) : helperText
          })
        );
      }
    }
  );
};

// src/index.ts
import {
  FormProvider,
  useForm,
  useFormContext as useFormContext2
} from "react-hook-form";
export {
  ControlledAsyncAutocomplete,
  ControlledAutocomplete,
  ControlledCheckbox,
  ControlledCodesAutocomplete,
  ControlledDatepicker,
  ControlledInput,
  ControlledOrganizationAutocomplete,
  ControlledProviderAutocomplete,
  ControlledRadioGroup,
  ControlledSelect,
  ControlledTextField,
  FormProvider,
  useForm,
  useFormContext2 as useFormContext
};
